import {accountLocation} from '../../src/account-routes';
/** These derived fields preserve a work-chat selection across account pages. */
export function workspaceContextQuery(search: string): string {
  const source = new URLSearchParams(search);
  const context = new URLSearchParams();
  for (const key of ['chat', 'agent', 'role']) {
    const value = source.get(key);
    if (value !== null) context.set(key, value);
  }
  const query = context.toString();
  return query ? `?${query}` : '';
}

/** Explicit sign-out must not hand the next account another account's chat. */
export function clearWorkspaceContext(): void {
  const url = new URL(window.location.href);
  const location = accountLocation(url.pathname, url.search, import.meta.env.BASE_URL.replace(/\/$/, ''));
  url.pathname = location.pathname;
  url.search = location.search;
  for (const key of ['chat', 'agent', 'role']) url.searchParams.delete(key);
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
  window.dispatchEvent(new PopStateEvent('popstate'));
}
